import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

export type FeatureFlagValue = any

export interface FeatureFlagsState {
  flags: Record<string, FeatureFlagValue>
}

export const featureFlagsInitialState: FeatureFlagsState = {
  flags: {},
}

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState: featureFlagsInitialState,
  reducers: {
    setFeatureFlag(state: FeatureFlagsState, action: PayloadAction<{ key: string; value: FeatureFlagValue }>) {
      state.flags[action.payload.key] = action.payload.value
    },
    setFeatureFlags(state: FeatureFlagsState, action: PayloadAction<Record<string, FeatureFlagValue>>) {
      state.flags = { ...state.flags, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => featureFlagsInitialState)
  },
})

export const { setFeatureFlag, setFeatureFlags } = featureFlagsSlice.actions

export default featureFlagsSlice.reducer
